// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap';
import $ from 'jquery';
import VueHead from 'vue-head'

Vue.use(VueHead)
window.$ = $;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  }
})

router.beforeEach((to, from, next) => {
	$('.navbar-collapse').collapse('hide')
	next()
})



// WEBPACK FOOTER //
// ./src/main.js